var close_filter = document.querySelector(".product-grid-container");
var reset_button = document.querySelectorAll(".mobile-facets__clear-wrapper");
var remove_class = document.querySelector(".mobile-facets__disclosure");

function openMenu() {
  if(reset_button){
    reset_button.forEach(function(anchor) {
       anchor.addEventListener("click",function () {
         remove_class.removeAttribute("open");
         remove_class.classList.remove("menu-opening");
      });
    }); 
  }
}

const myTimeout = setTimeout(openMenu, 5000);

if(close_filter){
   close_filter.addEventListener("click",function () {
   remove_class.removeAttribute("open");
   remove_class.classList.remove("menu-opening");
 });
}

// var grandchild = document.querySelector(".collection_list_btn");
// if(grandchild){
//   var grandchild = document.querySelectorAll(".child-div-text");
//   if(grandchild){
//     grandchild.forEach(function(child) {
//       child.classList.add("hidden");
//         var parent = child.closest(".child_text_main");
//       parent.classList.add("hidden");
//     }); 
//   }
// }
// else{
//   var grandchild = document.querySelectorAll(".child-div-text");
//   if(grandchild){
//     grandchild.forEach(function(child) {
//       child.classList.remove("hidden");
//       var parent = child.closest(".child_text_main");
//       parent.classList.remove("hidden");
//     }); 
//   }
// }
// size chart pdp page

  // Open size chart drawer
  $('.chart-drawer-trigger').on('click', function(e) {
    console.log("");
      e.preventDefault();
      $('.size-chart-drawer').addClass('active');
      $('.gradient').addClass('sizeChartOpen');
  });

  // Close size chart drawer
  $('.drawer-close').on('click', function() {
      $('.size-chart-drawer').removeClass('active');
    $('.gradient').removeClass('sizeChartOpen');
  });

  var size_content_1 = document.querySelector(".tab-1");
  var size_content_2 = document.querySelector(".tab-2");
  var size_btn1 = document.querySelector(".size_btn1");
  var size_btn2 = document.querySelector(".size_btn2");
  
    if(size_content_1){
      size_content_1.style.display="block";
    }
    
    if(size_content_2){
    size_content_2.style.display="none";
    }
    
    if(size_btn1){
      size_btn1.onclick = function () {
        size_btn1.classList.add("active");
        size_btn2.classList.remove("active");
        size_content_1.style.display="block";
        size_content_2.style.display="none";
      }
    }
    
    if(size_btn2){
      size_btn2.onclick = function () {
        size_btn1.classList.remove("active");
        size_btn2.classList.add("active")
        size_content_2.style.display="block";
        size_content_1.style.display="none";
      }
    }

// var active_link = document.querySelectorAll(".menu-list");
// // console.log("active_link",active_link);

// var active_link = document.querySelectorAll(".menu-list");
// console.log("active_link",active_link);

//   active_link.forEach(function(anchor) {
//     anchor.addEventListener("click",function () {
//       console.log("anchor",anchor);
//         body.classList.toggle("active");
//     });
    
//   });

$(document).ready(function() {

  // accordions js start
        function faq_taggol() {
              const accordions = document.querySelectorAll("[js-acc-item]");
              const openAccordion = (accordion) => {
                const content = accordion.querySelector("[js-acc-single-content]");
                accordion.classList.add("active");
                content.style.maxHeight = content.scrollHeight + "px";
              };
              
              const closeAccordion = (accordion) => {
                const content = accordion.querySelector("[js-acc-single-content]");
                accordion.classList.remove("active");
                if(content){
                  content.style.maxHeight = null;
                }
              };
              
              accordions.forEach((accordion) => {
                const intro = accordion.querySelector("[js-acc-single-trigger]");
                const content = accordion.querySelector("[js-acc-single-content]");
                if(intro && content){
                    intro.onclick = (e) => {
                      if (content.style.maxHeight) {
                        closeAccordion(accordion);
                      } else {
                        accordions.forEach((accordion) => closeAccordion(accordion));
                        openAccordion(e.target.closest('[js-acc-item]'));
                      }
                    };
                }
              });
        }
      faq_taggol();
  
  // home-page shop the view parent
    var parentSwiper = new Swiper('.shop-the-look-swiper', {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 65,
      loop: false,
      navigation: {
        nextEl: '.shop-next',
        prevEl: '.shop-prev',
      }
    });

    // home-page shop the view child
    document.querySelectorAll('.swiper-set-child').forEach(function(childSwiperContainer) {
      new Swiper(childSwiperContainer, {
        grabCursor: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 20,
        loop: false,
        navigation: {
          nextEl: '.shop-child-next',
          prevEl: '.shop-child-prev',
        },
        breakpoints: {
          376: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
        },
      });
    });

  // home page hotspot 
  var hotspot_title = document.querySelectorAll(".focal_point"); 
  hotspot_title.forEach(function(data_title) {
    data_title.addEventListener("mouseenter", (e) => {              
        // var targetIndex = $('.tab_inner_sec .card-item').index($('.card-item[data-product-title="'+ data_title.dataset.title +'"]'));
      var targetIndex = data_title.closest('.swiper').querySelector('.card-item[data-product-title="'+ data_title.dataset.title +'"]').getAttribute('data-attr');
      var targetIndex_swiper = document.querySelector('[data-product-title="'+ data_title.dataset.title +'"]').closest('.swiper-set-child')?.swiper || false;
         if(targetIndex_swiper){
          targetIndex_swiper.slideTo(targetIndex,200,false);
         }
    });
  });


  // home page latest news
   var parentSwiper = new Swiper('.latest-news-swiper', {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 65,
      loop: false,
      autoHeight: true,
      pagination:{
         el: ".news-pagination",
        clickable: true,
      }
    });
  
  // home-page review 
  // var swiper_slider = new Swiper("#craouselContainer", {
  //     effect: "coverflow",
  //     grabCursor: true,
  //     centeredSlides: true,
  //     coverflowEffect: {
  //       rotate: 0,
  //       stretch: 0,
  //       depth: 100,
  //       modifier: 4,
  //       slideShadows: true
  //     },
  //     // Navigation arrows
  //     navigation: {
  //       nextEl: ".review-swiper-button-next",
  //       prevEl: ".review-swiper-button-prev"
  //     },
  //     keyboard: {
  //       enabled: true
  //     },
  //     mousewheel: {
  //       thresholdDelta: 70
  //     },
  //     breakpoints: {
  //       560: {
  //         slidesPerView: 2.5
  //       },
  //       768: {
  //         slidesPerView: 3
  //       },
  //       1024: {
  //         slidesPerView: 3
  //       }
  //     }
  // });


});

// Collection Filter Toggleclass JS
if ($(window).width() > 750) {
$('.facets__heading').click(function(){
  $(this).toggleClass('filter_active');
   $('#FacetsWrapperDesktop').toggleClass('dd_cm_filter');
});
}

if ($(window).width() < 750) {
$('.facets__heading').click(function(){
  $('.mobile-facets__open-wrapper').click();
});
}

///// Tab Faq
$(document).on('click','.acctab_title', function(e){
   if($(window).width() >= 768){
      $('.acctab_title').removeClass('active-accor');
      $(this).addClass('active-accor');
      $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
      $($(this).attr('data-act-title')).addClass('activemain-tab').show();
   }else{
     $('.acctab_title').removeClass('active-accor');
      $(this).addClass('active-accor');
      $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
      $($(this).attr('data-act-title')).addClass('activemain-tab').show();
      // $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
      $('.acc_tab-inner .acc-tab-content').addClass('tab-content-show').show();
      $($(this).attr('data-act-title')).addClass('activemain-tab').show();
   }
});
$(document).on('click','.acc_tab-inner .acc-tab-content .back__arrow', function(e){
    $('.acc_tab-inner .acc-tab-content').removeClass('tab-content-show').show();
});
// $('.acc-container .acc:nth-child(1) .acc-head').addClass('active');
// $('.acc-container .acc:nth-child(1) .acc-content').slideDown();
$('.acc-head').on('click', function() {
    if($(this).hasClass('active')) {
      $(this).siblings('.acc-content').slideUp();
      $(this).removeClass('active');
    }
    else {
      $('.acc-content').slideUp();
      $('.acc-head').removeClass('active');
      $(this).siblings('.acc-content').slideToggle();
      $(this).toggleClass('active');
    }
});

